/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LanguageLocaleDto } from '../../models/language-locale-dto';
import { UpsertLanguageLocaleCommand } from '../../models/upsert-language-locale-command';

export interface ApiAdminLanguageLocalesPost$Params {
      body?: UpsertLanguageLocaleCommand
}

export function apiAdminLanguageLocalesPost(http: HttpClient, rootUrl: string, params?: ApiAdminLanguageLocalesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<LanguageLocaleDto>> {
  const rb = new RequestBuilder(rootUrl, apiAdminLanguageLocalesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LanguageLocaleDto>;
    })
  );
}

apiAdminLanguageLocalesPost.PATH = '/api/Admin/language-locales';
